import { Chain } from "@rainbow-me/rainbowkit";
import { AAVEIcon, DAIIcon, EURSIcon, GASIcon, LINKIcon, NEOIcon, SWTHIcon, USDCIcon, USDTIcon, WBTCIcon, WETHIcon, WSTETHIcon, WMIcon } from "../../assets";
import { FunctionComponent, SVGProps } from "react";
import { connectorsForWallets } from '@rainbow-me/rainbowkit'
import { metaMaskWallet, walletConnectWallet, rainbowWallet, coinbaseWallet, trustWallet, ledgerWallet, imTokenWallet } from '@rainbow-me/rainbowkit/wallets'
import { createConfig, http } from "wagmi";
import { createClient } from "viem";

export const DECIMALS = 18;
export const PRICE_DECIMALS = 8; //TODO: temp placeholder
export const RAY_DECIMALS = 27;
export const ORACLE_BASE_CURRENCY_UNIT_DECIMALS = 8;
export const BASE_TOKEN = 'USDC'; //TODO: Temp placeholder
export const MAX_SPENDING_LIMIT = '115792089237316195423570985008687907853269984665640564039457584007913129639935'
export const SECONDS_PER_YEAR = 31536000
export const poolProviderAddress = `0xfa512d40F96449E2c6Ee304aFb4951e900d1dEB8` as `0x${string}`

interface TokenMapping {
  [key: string]: {
    name: string;
    iconUrl: FunctionComponent<SVGProps<SVGSVGElement>>;
    // decimals: number;
    // contractAddress: `0x${string}`;
  };
}

//use Uppercase for the key
export const tokenMapping: TokenMapping = {
  'USDC': {
    name: 'USD Coin',
    iconUrl: USDCIcon,
  },
  'DAI': {
    name: 'DAI Coin',
    iconUrl: DAIIcon,
  },
  'LINK': {
    name: 'LINK Coin',
    iconUrl: LINKIcon,
  },
  'WBTC': {
    name: 'Wrapped Bitcoin',
    iconUrl: WBTCIcon,
  },
  'WETH': {
    name: 'Wrapped Ethereum',
    iconUrl: WETHIcon,
  },
  'WSTETH': {
    name: 'Wrapped Staked Ethereum',
    iconUrl: WSTETHIcon,
  },
  'USDT': {
    name: 'USD Tether',
    iconUrl: USDTIcon,
  },
  'AAVE': {
    name: 'AAVE Coin',
    iconUrl: AAVEIcon,
  },
  'EURS': {
    name: 'EUR Coin',
    iconUrl: EURSIcon,
  },
  'SWTH': {
    name: 'Switcheo Token',
    iconUrl: SWTHIcon,
  },
  'NEO': {
    name: 'Neo',
    iconUrl: NEOIcon,
  },
  'WGAS': {
    name: 'Wrapped GAS',
    iconUrl: GASIcon,
  },
  'WGAS10': {
    name: 'Wrapped GAS',
    iconUrl: GASIcon,
  },
  'WM': {
    name: 'Wrapped MEME',
    iconUrl: WMIcon,
  },
}

export const siteMap = {
  markets: { path: "/", name: "MARKETS", display: true },
  portfolio: { path: "/portfolio", name: "PORTFOLIO", display: true },
  tokenDetails: { path: "/token/:denom", name: "Token Details", display: false },
  wallet: { path: "/wallet", name: "Wallet", display: false },
  // rewards: { path: "/rewards", name: "REWARDS", display: true },
}

export const socialLinks = {
  discord: "",
  twitter: "https://x.com/memelend77",
  github: "",
  telegram: "",
  docs: "https://docs.memelend.org"
}

export const apiLinks = {
  testnet: "https://test-api.memelend.org",
  mainnet: "https://api.memelend.org"
}

export const MemeCoreTestnet = {
  id: 43521,
  name: 'Formicarium Testnet',
  iconUrl: 'https://static.oklink.com/cdn/assets/imgs/2411/38CA1A73AAB98F54.png?x-oss-process=image/format,webp/resize,w_72,h_72,type_6/ignore-error,1',
  iconBackground: '#fff',
  nativeCurrency: { name: 'M', symbol: 'M', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.formicarium.memecore.net'] },
  },
  blockExplorers: {
    default: { name: 'Formicarium.MemeCoreScan', url: 'https://formicarium.memecorescan.io/' },
  },
  contracts: {
    // multicall3: {
      // address: '0x82096F92248dF7afDdef72E545F06e5be0cf0F99', //TODO: temp placeholder
      // blockCreated: 11_907_934,
    // },
  },
} as const satisfies Chain;

export const MemeCoreMainnet = {
  id: 4352,
  name: 'MemeCore Mainnet',
  iconUrl: 'https://s2.coinmarketcap.com/static/img/coins/64x64/35491.png',
  iconBackground: '#fff',
  nativeCurrency: { name: 'M', symbol: 'M', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.memecore.net/'] },
  },
  blockExplorers: {
    default: { name: 'MemeCoreScan', url: 'https://memecorescan.io' },
  },
  contracts: {
    // multicall3: {
    //   address: '0x82096F92248dF7afDdef72E545F06e5be0cf0F99',
    //   // blockCreated: 11_907_934,
    // },
  },
} as const satisfies Chain


const connectors = connectorsForWallets(
  [
    {
      groupName: 'Supported Wallets',
      wallets: [
        metaMaskWallet,
        walletConnectWallet,
        rainbowWallet,
        coinbaseWallet,
        trustWallet,
        ledgerWallet,
        imTokenWallet,
      ],
    }
  ],
  {
    appName: 'Intersect',
    projectId: 'NEOX_INTERSECT',
  })

export const config = createConfig({
  connectors,
  chains: [MemeCoreTestnet, MemeCoreMainnet],
  ssr: false,
  client({ chain }) {
    return createClient({ chain, transport: http() })
  },
  multiInjectedProviderDiscovery: false // Dont show installed wallets (Some are not supported)
});